import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

interface StoreModalCtx {
  open: () => void;
  close: () => void;
  isOpen: boolean;
}

const Ctx = createContext<StoreModalCtx | null>(null);

export const StoreModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, close]);

  return <Ctx.Provider value={{ open, close, isOpen }}>{children}</Ctx.Provider>;
};

export const useStoreModal = () => {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useStoreModal must be used inside StoreModalProvider');
  return ctx;
};
